import { CoreState } from '../modules';

export const changeOrderStatusPending = (state: CoreState) =>
  state.order.changeOrderStatusPending;

export const updateOrderCallbackPending = (state: CoreState) =>
  state.order.updateOrderCallbackPending;
